<template>
  <div>
    <center> <img :src="imgUrl" style="width: 100%;margin-bottom: -6px;"></center>
    <div class="demo-bg">
      <div class="demo" v-html = "dataL['content']"> </div>
    </div>
  </div>
</template>

<script>

export default {
data() {
    return {
      imgUrl: "",
      dataL: {},
    };
  },
  created() {   
    this.$http.get("api/vue_support/get_newscard?uid="+this.$route.query.uid).then((response) => {
      this.dataL = JSON.parse(response.data.data);
      console.log(this.dataL);
      console.log(this.dataL["title"]);
    });
    this.$http.get("api/vue_support/get_support_top_img").then((response) => {
      this.imgUrl = response.data.data
    });
  }
}
</script>

<style lang="less" scoped>

.demo-bg{
  background-color: #fff;

}
/deep/.demo{
  width: 100%; margin: 0px auto;
  max-width: 800px;min-height: 400px;
  text-align: left;
  
  h1,h2 {text-align: center;}
  p{
    text-indent: 2em;
    line-height: 30px;
  }
  img {
    max-width: 600px;
    position: relative;
    left: 50%;
    transform: translate(-50%,0%);
  }
}

</style>
